module.exports = __webpack_public_path__ + "static/IMG_1392-c69351662e0ef4a6a34a741c2842e1c8.jpg";